import React from 'react'

export default () => {

  return (
    <div className="loader w-full text-center mt-8 font-bold text-sm letter-spacing-[2px]">
      <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div className="block">loading...</div>
    </div>
  )
}